import { CardPanel, Row, Col, } from 'react-materialize';
import reinOnKeys from './../data/img/rein-on-keys.jpg';
import bio from './../data/img/bio.jpg';


const Home2 = () => {
    return (
        <Row>
            <CardPanel className="black panel">
                <Row>
                    <Col s={12} m={12} l={7}>
                        <img alt="Bio" src={bio}></img>
                    </Col>
                    <Col s={12} m={12} l={5}>
                        <img alt="Rein.Likely" src={reinOnKeys}></img>
                    </Col>
                </Row>
            </CardPanel>
        </Row>
    )
};

export default Home2;